import { render, staticRenderFns } from "./MyTherapys.vue?vue&type=template&id=b23cc4f2&"
import script from "./MyTherapys.vue?vue&type=script&lang=js&"
export * from "./MyTherapys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports